import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Text } from '@mantine/core'
import { Button } from '@/components/Elements'
import { BookingReportModal } from '@/components/Elements/Modals/BookingReportModal'
import { chatChatsList } from '@/features/chat/store'
import { ChatModel, MessageType } from '@/features/chat/types/models'
import { userData } from '@/features/user/store'
import { usePopup } from '@/hooks'
import useStyles from './Message.styles'

interface IProps {
  message: MessageType
  activeChat: ChatModel
}

export const Message = ({ message, activeChat }: IProps) => {
  const { t } = useTranslation()

  const { classes, cx } = useStyles()
  const dispatch = useDispatch()
  const { visible: reportVisible, open: reportOpen, close: reportClose } = usePopup()

  const isAttachmentsOnly = message?.files && message?.files?.length > 0 && !message?.body
  const isImageOnly = message?.image && !message?.body

  const onReportSubmitted = () => {
    dispatch(
      chatChatsList.updateBookingFromReport({
        id: activeChat.id,
        pending_booking_report: [],
      })
    )
    dispatch(userData.remove1UnreadMessages())
  }

  return (
    <>
      <Text color={'gray.6'} className={cx(classes.message, 'truncate')} size={'sm'}>
        {isAttachmentsOnly || isImageOnly || message?.body ? (
          <>
            {message?.is_my && <span>{t('you')}: </span>}

            {isAttachmentsOnly ? (
              <span>{t('attachments')}</span>
            ) : isImageOnly ? (
              <span>{t('image')}</span>
            ) : (
              message?.body
            )}
            {message.show_report_button && (
              <div className="w-100 text-center mt-2">
                <Button size={'xs'} onClick={() => reportOpen(true)}>
                  {t('report.request.click')}
                </Button>
              </div>
            )}
          </>
        ) : (
          t('no_messages')
        )}
      </Text>

      <BookingReportModal
        visible={reportVisible}
        onLoginModalClose={reportClose}
        onSaveReport={onReportSubmitted}
        bookingReportId={activeChat.booking?.pending_booking_report?.[0]}
        bookingReportClient={
          activeChat.booking?.user.first_name +
          (activeChat.booking?.user.last_name ? ' ' + activeChat.booking?.user.last_name : '')
        }
        bookingReportChildren={activeChat.booking?.children_names}
      />
    </>
  )
}
